<form class="flex grow flex-col gap-4" [formGroup]="formGroup">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Is</mat-label>
    <mat-select formControlName="comparison" required>
      @for (comparison of comparisons; track comparison) {
        <mat-option [value]="comparison.value">
          {{ comparison.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Value</mat-label>
    @switch (formatter().formatter) {
      @case ('prefix') {
        <span matTextPrefix>{{ formatter().prefix }}&nbsp;</span>
      }
      @case ('suffix') {
        <span matTextSuffix>&nbsp;{{ formatter().suffix }}</span>
      }
      @case ('currency') {
        <span matTextPrefix>$&nbsp;</span>
      }
      @case ('percentage') {
        <span matTextSuffix>%</span>
      }
      @case ('minutes') {
        <span matTextSuffix>mins</span>
      }
    }
    <input matInput type="number" formControlName="value" required />
  </mat-form-field>
</form>
